var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar_wrapper row justify-content-center"},[_c('div',{staticClass:"col-xl-4 order-xl-8"},[_c('unavailability-helpers')],1),_vm._v(" "),_c('div',{staticClass:"col-xl-8"},[_c('div',{class:{ 'editable-calendar': _vm.editable },attrs:{"id":"calendar_month"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91f4732e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unavailabilityCalendars/UnavailabilityCalendarMonthly.vue
// module id = jYR6
// module chunks = 1